import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginPageStyled } from './LoginPageStyled';
import { AuthStyled } from '../../style/auth/authStyled';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import { Button, Card, Carousel, Col, Image, Row } from 'react-bootstrap';
import AlertComponent from '../../component/alert/AlertComponent';
import logo from '../../images/Logo intelidente Lite Branca.png';
import { PublicRoutes } from '../../../main/constant/RouteConstant';

interface InputsLogin {
  login: string;
  password: string;
}

interface CarouselItem {
  image: string;
  title: string;
  content: string;
}

type Props = {
  authentication: (params: { login: string; password: string }) => Promise<any>;
};

const LoginPage: React.FC<Props> = ({ authentication }: Props) => {
  const { register, getValues } = useForm<InputsLogin>();
  let navigate = useNavigate();

  const handleLogin = async () => {
    await authentication({ login: getValues('login'), password: getValues('password') });
  };

  const handleEsqueciMinhaSenha = () => {
    navigate(PublicRoutes.FORGOT_PASSWORD);
  };

  const handleNovaClinica = () => {
    navigate(PublicRoutes.CREATE_CLINIC);
  };

  const TIME_INTERVAL_CAROUSEL = 5000;
  const carouselItems: CarouselItem[] = [
    {
      image: require('../../images/Carrousel1.jpg'),
      title: 'Ambiente Moderno',
      content: 'Sua clínica com uma estrutura acolhedora e moderna.',
    },
    {
      image: require('../../images/Carrousel2.jpg'),
      title: 'Tecnologia de Ponta',
      content: 'Equipamentos modernos para garantir o melhor atendimento.',
    },
    {
      image: require('../../images/Carrousel3.jpg'),
      title: 'LUME',
      content: 'O INTELIDENTE fornece informações essenciais para auxiliar sua empresa nas tomadas de decisões estratégicas.',
    },
    {
      image: require('../../images/Carrousel4.jpg'),
      title: 'Equipe Especializada',
      content: 'Contamos com os melhores profissionais do mercado.',
    },
  ];

  return (
    <AuthStyled>
      <AlertComponent />
      <div style={{ overflow: 'hidden' }}>
        <Row>
          <Col md={7} sm={12} style={{ minHeight: '100vh' }}>
            <Carousel>
              {carouselItems.map((item, index) => (
                <Carousel.Item interval={TIME_INTERVAL_CAROUSEL} style={{ height: '100vh' }} key={index}>
                  <img
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    src={item.image}
                    alt="Slide"
                  />
                  <Carousel.Caption>
                    <Card className="opacity-75 text-dark">
                      <Card.Body>
                        <Card.Title>{item.title}</Card.Title>
                        <Card.Text>{item.content}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </Col>
          <Col md={5} sm={12} className="d-flex justify-content-center align-items-center">
            <LoginPageStyled>
              <div className="imagen">
                <Image src={logo} width={300} className="img-fluid" />
              </div>
              <div className="form-login">
                <Form>
                  <Form.Group className="mb-3 label-email" controlId="formGroupEmail">
                    <Form.Label>Login</Form.Label>
                    <Form.Control className="input-email" type="email" {...register('login')} />
                  </Form.Group>
                  <Form.Group className="mb-3 label-senha" controlId="formGroupPassword">
                    <Form.Label>Senha</Form.Label>
                    <Form.Control className="input-senha" type="password" {...register('password')} />
                  </Form.Group>
                  <Button className="btn-entrar" size="lg" variant="primary" onClick={handleLogin}>
                    Entrar
                  </Button>
                  <Button className="link-esqueci-senha" size="lg" variant="link" onClick={handleEsqueciMinhaSenha}>
                    Esqueci minha senha
                  </Button>
                </Form>
              </div>
              <div className="btn-footer text-center">
                <Button className="btn-nova-clinica" size="lg" variant="outline-primary" onClick={handleNovaClinica}>
                  Cadastrar nova clínica
                </Button>
                <p className="text-footer">
                  2016- 2024 Lume Tecnologia - v.1.0.0.1
                  <br />
                  Fale conosco: atendimento@lumegrupo.com.br
                </p>
              </div>
            </LoginPageStyled>
          </Col>
        </Row>
      </div>
    </AuthStyled>
  );
};

export default LoginPage;
